import {
  SET_MATER_TIME_OFF_TYPES,
  SET_MY_REQUESTS,
  SET_PENDING_REQUESTS,
  SET_PTO_TYPES,
  SET_MATER_TIME_OFF_PLANS,
  SET_TEAM_REQUESTS,
  SET_TIME_OFF_DETAILS,
} from '../actions/time-off';

const initialState = {
  ptoTypes: [],
  timeOffDetails: [],
  myRequests: {
    onlyPast: false,
  },
  pendingRequests: {
    onlyPast: false,
  },
  teamRequests: {
    onlyPast: false,
  },
  masterTimeOffTypes: [],
  masterTimeOffPlans: [],
};

const ptoReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PTO_TYPES:
      return {
        ...state,
        ptoTypes: action.payload,
      };
    case SET_TIME_OFF_DETAILS:
      return {
        ...state,
        timeOffDetails: action.payload,
      };
    case SET_MY_REQUESTS:
      return {
        ...state,
        myRequests: action.payload,
      };
    case SET_PENDING_REQUESTS:
      return {
        ...state,
        pendingRequests: action.payload,
      };
    case SET_TEAM_REQUESTS:
      return {
        ...state,
        teamRequests: action.payload,
      };
    case SET_MATER_TIME_OFF_TYPES:
      return {
        ...state,
        masterTimeOffTypes: action.payload,
      };
    case SET_MATER_TIME_OFF_PLANS:
      return {
        ...state,
        masterTimeOffPlans: action.payload,
      };
    default:
      return state;
  }
};

export default ptoReducer;
